import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-simpledialog',
  standalone: false,
  templateUrl: './simpledialog.component.html',
  styleUrl: './simpledialog.component.css'
})
export class SimpleDialogComponent {
  dialogRef = inject<MatDialogRef<SimpleDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);


  ok() {
    if (this.data.okCallback) {
      this.data.okCallback();
    }
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
